import { faCheck, faClose, faEdit, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import TooltipOverlay from '../../global/TooltipOverlay';
import PrimeTable, { verifiedBodyTemplate } from '../../PrimeTable/PrimeTable';
import { useMemo } from 'react';
import { Preloader, ThreeDots } from '../../global/Preloader';
import mainAxios from '../../../services/mainAxios';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Checkbox } from 'primereact/checkbox';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { Dialog } from "primereact/dialog";
import RegisterTCR from './RegisterEditTcr';
import Loader from '../../Layout/Loader';
import { useAppContext, usePersistedState } from '../../../AppContext';
import { classNames } from "primereact/utils";
import RegisterEditTcr from './RegisterEditTcr';
import moment from 'moment';
import ExportCsvPrime from '../../global/ExportCsvPrime';
import CellInput from '../../global/CellInput';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import CisMessage from '../../global/CisMessage';
import useEditInCisTcr from './useEditInCisTcr';
import { Column } from 'primereact/column';



const Tcrs = ({ company, setCompany }) => {

    const [tcrLoading, setTcrLoading] = useState({ id: null, loading: false });
    const [updateState, setUpdateState] = useState(null)
    const [tcrData, setTcrData] = useState()
    const [tcrForCsv, setTcrForCsv] = useState([]);
    const [editCurrentRow, setEditCurrentRow] = useState()
    const [expandedRows, setExpandedRows] = useState(null);
    const [expandedData, setExpandedData] = useState([]);
    const [loadingExpandData, setLoadingExpandData] = useState(false);
    const { t } = useTranslation("translations");
    const {
        user: [user],
        selectedCompany: [selectedCompany],
        getCompany
    } = useAppContext();

    const allTcrs = useMemo(() => {
        if (!company) return []
        return company.branches.reduce((acc, next) => acc.concat(next.tcrTypes), [])
    }, [company])
    const refreshGrid=()=>getTcrsFromCis({updatedFilters:filters,rowsPerPage:tableRows.rowsPerPage,currentPage:tableRows.currentPage})
    const {editTcrInCisActions,selectedRowsColumn} = useEditInCisTcr({tcrData,company,refreshGrid})
    const defaultFilters={params:{}}
    const [filters, setFilters] = React.useState(defaultFilters);
    const [loadingFromCis, setLoadingFromCis] = useState(false)
    const [tcrDialog, setTcrDialog] = useState({ visible: false, tcr: null })
    const [tableRows, setTableRows] = useState({
        totalRows: 0,
        rowsPerPage: 10,
        currentPage: 1,
    });
    const isSysAdmin=[1].includes(user?.role?.id)
    const handleChange = ({ key, value, tcr }) => {
        setUpdateState((updateState) => ({
            ...updateState,
            [tcr.id]: {
                ...(updateState?.[tcr?.id] ?? tcr),
                [key]: value
            }
        }))
    };

    const onRowExpand = async (event) => {
        setLoadingExpandData(true);
        setExpandedRows([event.data]);
    
        try {
            const content = await getTcrUsers(event.data.id);
    
            setExpandedData(content.filter(user => user.active === true));
        } catch (error) {
            console.error("Error expanding row with TCR users:", error);
            setExpandedData([]); // fallback
        }
    
        setLoadingExpandData(false);
    };
    

    const onRowCollapse = () => {
        setExpandedRows([]);
    };

    const getTcrUsers = async (tcrId) => {
        try {
            const response = await mainAxios.post("/apiEndpoint/search", {
                object: "GetTcrUsers",
                params: { tcrId: tcrId.toString() },
                company: company.id,
            });
            return response.data.content;
        } catch (error) {
            console.error("Error fetching TCR users:", error);
            return [];
        }
    };

    const rowExpansionTemplate = (data) => {
        if (loadingExpandData) return <Loader size="small" />
        return (
            <div className="prime-header-sticky" style={{ width: "70vw" }}>
                <PrimeTable
                   stripedRows={false}
                    value={expandedData}
                    columns={expansionColumns}
                    responsiveLayout="scroll"
                    simpleTable={true}
                    columnResizeMode="expand"
                    scrollable={true}
                    scrollHeight="350px"
                />
            </div>
        );
    };

    const expansionColumns = [
        {
            header: t("users.firstName"),
            field: "firstName",
            style: { minWidth: "120px", maxWidth: "120px" },
        },
        {
            header: t("users.lastName"),
            field: "lastName",
            style: { minWidth: "120px", maxWidth: "120px" },
        },
        {
            header: t("users.username"),
            field: "username",
            style: { minWidth: "140px", maxWidth: "140px" },
        },
        {
            header: "Email",
            field: "email",
            style: { minWidth: "120px", maxWidth: "250px" },
        },
        {
            header: t("users.role"),
            field: "role.name",
            style: { minWidth: "100px", maxWidth: "100px" },
        },
        {
            header: t("users.purchaseRoles"),
            field: "purchaseRole.name",
            style: { minWidth: "160px", maxWidth: "180px" },
        },
        {
            header: t("users.paymentRole"),
            field: "paymentsRole.name",
            style: { minWidth: "160px", maxWidth: "180px" },
        },
    ];

    React.useEffect(() => {
        getTCR()
    }, []);

    const getTCR = ({ updatedFilters, rowsPerPage = 10, currentPage = 1, exportCsv = false, sortCriteria } = {}) => {
        return mainAxios.post("/apiEndpoint/search", {
            object: "GetTcrView",
            params: updatedFilters?.params,
            pagination: exportCsv ? null : {
                pageSize: rowsPerPage,
                pageNumber: currentPage,
            },
            nuis: company.nuis,
            company: company.id,
            sortCriteria
        }).then((res) => {
            if (res?.data?.status === true) {
                if (exportCsv) {
                    setTcrForCsv(res.data.content)
                    return res.data.content
                } else {
                    setTcrData(res.data.content);
                    setTableRows((tableRows) => ({
                        ...tableRows,
                        totalRows: res?.data?.totalSize,
                    }));
                }
            }
            setTcrData(res.data.content ?? [])
            setTableRows((tableRows) => ({
                ...tableRows,
                totalRows: res?.data?.totalSize,
            }));
        }).catch(err => {
            console.log(err);
        })
    }

    const profiscActiveFilter = (filterOptions) => {
        let value = null
        if (filters?.params?.status === "100") {
            value = true
        } else if (filters?.params?.status === "-100") {
            value = false
        }
        return (
            <div className="d-flex justify-content-center">
                <TriStateCheckbox
                    value={value}
                    onChange={(e) => {
                        let value = null
                        if (e.value == true) value = "100"
                        else if (e.value == false) value = "-100"
                        let { currentPage, rowsPerPage, sortCriteria } = tableRows
                        filterOptions.filterCallback(e.value);

                        setFilters((filters) => {
                            const content = {
                                ...filters,
                                params: {
                                    ...filters.params,
                                    status: value
                                },
                            }
                            getTCR({ updatedFilters: content, rowsPerPage, currentPage, sortCriteria })
                            return content
                        })
                    }}
                />
            </div>
        )
    }

    const tcrColumns = [
        ({
            ...[1].includes(user?.role?.id) && ({
                header: t(["home.actions"]),
                field: "actions",
                style: { minWidth: 120, maxWidth: 200 },
                body: (tcr) => (
                    <Link to="#" className="table-action-link" onClick={(e) => {
                        e.preventDefault();
                        setTcrDialog({ visible: true, tcr })
                    }}>
                        <FontAwesomeIcon icon={faEdit} />
                        {t("company.edit")}
                    </Link>
                ),
                default:true,
                mobile: { priority: "action", group: "actions" },

            })
        }),
        {
            header: t("purchases.allowPurchases"),
            field: "allowPurchase",
            style: { minWidth: 160, maxWidth: 200 },
            sortable: true,
            filter: true,
            filterType: "TRISTATECHECKBOX",
            dataType: "boolean",
            default:true,
            mobile: { priority: 1, group: "details" },
        },
        {
            header: t("purchases.allowInvoices"),
            field: "allowInvoice",
            style: { minWidth: 150, maxWidth: 200 },
            sortable: true,
            filter: true,
            filterType: "TRISTATECHECKBOX",
            dataType: "boolean",
            default:true,
            mobile: { priority: 1, group: "details" },

        },
        // {
        //     header: t("invoice.operatorCode"),
        //     field: "operatorCode",
        //     style: { minWidth: 150, maxWidth: 200 },
        //     // filter: true
        // },
        {
            header: t("stat.tcrCode"),
            field: "tcrCode",
            style: { minWidth: 150, maxWidth: 200 },
            sortable: true,
            filterConfig: {
                like: true
            },
            filter: true,
            default:true,
            mobile: { priority: 1, isTitle: true, group: "identity" },
        },
        {
            header: t("purchases.warnings"),
            field: "expiresThisMonth",
            style: { minWidth: 200, maxWidth: 200 },
            body: (user) => {
                const currentDate = new Date()
                return (
                    <>
                        {moment(currentDate).isBefore(user?.validTo) &&
                            moment(currentDate).isSame(user?.validTo, 'month') ? (
                            <div style={{ backgroundColor: '#ffc107', color: '#664d03', padding: '2px 7px', borderRadius: '5px', fontSize: "13px", fontWeight: "500", display: 'inline-flex', alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
                                {t(["company.expiresWarning"])}
                            </div>
                        ) : null
                        }
                        {moment(currentDate).isAfter(user?.validTo) ?
                            <div style={{ backgroundColor: '#e03131', color: '#ffffff', padding: '2px 7px', borderRadius: '5px', fontSize: "13px", fontWeight: "500", display: 'inline-flex', alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
                                {t("company.hasExpired")}
                            </div> : null
                        }
                    </>

                )
            },
            default:true
        },
        {
            header: t("nslf.softCode"),
            field: "softwareCode",
            style: { minWidth: 150, maxWidth: 200 },
            sortable: true,
            filter: true,
            default:true,
            mobile: { priority: 1, group: "reference" },
        },
        {
            header: t("purchases.bussinesCode"),
            field: "businUnitCode",
            style: { minWidth: 160, maxWidth: 200 },
            sortable: true,
            filter: true,
            mobile: { priority: 1, group: "identity" },
        },
        {
            header: t("purchases.technical"),
            field: "isTechnical",
            filterConfig: {
                field: "isTechnical"
            },
            filter: true,
            style: { minWidth: 150, maxWidth: 200 },
            sortable: true,
            filterType: "TRISTATECHECKBOX",
            dataType: "boolean",
            default:true
        },
        {
            header: t("subscription.validFrom"),
            field: "validFrom",
            style: { minWidth: 160, maxWidth: 200 },
            sortable: true,
            formattedExportValue: true,
            body: (tcr) =>
                tcr?.validFrom
                    ? moment(tcr?.validFrom).format("DD/MM/YYYY HH:mm")
                    : "",
            default:true,
            mobile: { priority: 1, group: "dates" },

        },
        {
            header: t("subscription.validTo"),
            field: "validTo",
            style: { minWidth: 150, maxWidth: 200 },
            body: (tcr) =>
                tcr?.validTo
                    ? moment(tcr?.validTo).format("DD/MM/YYYY HH:mm")
                    : "",
            formattedExportValue: true,
            default:true,
            mobile: { priority: 1, group: "dates" },


        },
        {
            header: t("invoice.type"),
            field: "type",
            sortable: true,
            default:true,
            mobile: { priority: 1, group: "details" },
            // filter:true,
            // filterType: "DROPDOWN",
            // filterField:"type",
            // filterConfig: {
            //     options: typeOptions,
            //     optionValue: "value",
            //     optionLabel: "label",
            // },
        },
        {
            header: t("selfServices.existInCis"),
            field: "existCis",
            dataType: "boolean",
            style: { minWidth: 170, maxWidth: 200 },
            sortable: true,
            filter: true,
            filterType: "TRISTATECHECKBOX",
            dataType: "boolean",
            default:true,
            mobile: {
                priority: 1,
                isBadge: true,
                group: "status",
                mobileBody: (row) => (
                    <span style={{
                        backgroundColor: row.existCis ? '#d4edda' : '#f8d7da',
                        color: row.existCis ? '#155724' : '#721c24',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        fontWeight: 500
                    }}>
                        {row.existCis ? 'Aktive ne CIS' : 'Jo Aktive ne CIS'}
                    </span>
                ),
            },
            // filter:true,
            // filterType: "DROPDOWN",
            // filterField:"type",
            // filterConfig: {
            //     options: typeOptions,
            //     optionValue: "value",
            //     optionLabel: "label",
            // },
        },
        {
            header: t("selfServices.lastUsed"),
            field: "lastUsed",
            style: { minWidth: 190, maxWidth: 200 },
            sortable: true,
            formattedExportValue: true,
            body: (tcr) => tcr?.lastUsed
                ? moment(tcr?.lastUsed).format("DD/MM/YYYY HH:mm")
                : "",
            default:true
            
        },
        {
            header: t("selfServices.lastModified"),
            field: "modificationDate",
            style: { minWidth: 200, maxWidth: 200 },
            sortable: true,
            formattedExportValue: true,
            body: (tcr) => tcr?.modificationDate
                ? moment(tcr?.modificationDate).format("DD/MM/YYYY HH:mm")
                : "",
            default:true
            
        },
        {
            header: t("selfServices.lastModifiedUser"),
            field: "modificationUser",
            filter: true,
            style: { minWidth: 200, maxWidth: 220 },
            sortable: true,
        },
        {
            header: t("selfServices.profiscActive"),
            field: "profiscActive",
            body: (row) => verifiedBodyTemplate(row.status === 100),
            format: (row) => { return row.status != null ? (row.status === 100 ? "TRUE" : "FALSE") : "" },
            formattedExportValue: true,
            style: { minWidth: 170, maxWidth: 220 },
            sortable: true,
            filter: true,
            filterElement: (filterOptions) => profiscActiveFilter(filterOptions),
            default:true,
            mobile: {
                priority: 1,
                isBadge: true,
                group: "status",
                mobileBody: (row) => (
                    <span style={{
                        backgroundColor: row.status === 100 ? '#d4edda' : '#f8d7da',
                        color: row.status === 100 ? '#155724' : '#721c24',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        fontWeight: 500
                    }}>
                        {row.status === 100 ? 'Aktive ne Profisc' : 'Jo Aktive ne Profisc'}
                    </span>
                ),
            },

        },
        {
            header: t("selfServices.lastInvoiceNumber"),
            field: "lastInvoiceNumber",
            filter: true,
            style: { minWidth: 190, maxWidth: 220 },
            body: (tcr) => <CellInput value={tcr?.lastInvoiceNumber ?? ""} width={200} onFocus={(event) => event.target.select()} />,
            sortable: true,
            default:true
        },
        {
            header: t("company.nextNumber"),
            sortable: true,
            filter: true,
            field: "nextNumber",
            style: { minWidth: "160px", maxWidth: "160px" },
            default:true

        },
        {
            header: t("company.TCRIntId"),
            sortable: true,
            filter: true,
            field: "tcrIntID",
            style: { minWidth: "140px", maxWidth: "140px" },
            default:true
        },
        {
            header: t("company.cisUpdate"),
            sortable: true,
            field: "cisLastUpdate",
            body: (tcr) =>
                tcr?.cisLastUpdate
                    ? moment(tcr?.cisLastUpdate).format("DD/MM/YYYY HH:mm")
                    : "",
            style: { minWidth: "240px", maxWidth: "250px" },
            formattedExportValue: true,
            default: true,
        },
        {
            header: t("company.unRegisteredInCis"),
            sortable: true,
            filter: true,
            default:true,
            field: "unRegisterInCis",
            filterType:"TRISTATECHECKBOX",
            dataType:"boolean",
            style: { minWidth: "180px", maxWidth: "180px" },
        },
        {
            header: t("nslf.maintainerCode"),
            sortable: true,
            filter: true,
            default:true,
            field: "maintainerCode",
            style: { minWidth: "170px", maxWidth: "170px" },
        },
        {
            header: t("company.unRegisterDate"),
            sortable: true,
            filter: true,
            default:true,
            field: "unRegisterDate",
            body: (tcr) =>
                tcr?.unRegisterDate
                    ? moment(tcr?.unRegisterDate).format("DD/MM/YYYY HH:mm")
                    : "",
            formattedExportValue: true,
            style: { minWidth: "240px", maxWidth: "240px" },
        },


    ]


    const [selectedColumns, setSelectedColumns] = usePersistedState(
        tcrColumns.map((col) => ({ field: col.field, show: !!col.default, ...(col?.persisted ? { persisted: true } : {}) })),
        "tcrColumns2"
    );

    const getTcrsFromCis = () => {
        setLoadingFromCis(true)
        mainAxios.post("/endpoint/v3/getDataFromCis", {
            object: "GetTcrView",
            value: null,
            nuis: company.nuis,
            company: company.id
        },)
            .then(res => {
                setLoadingFromCis(false)
                if (res.data.status) {
                    getTCR({ updatedFilters: filters, currentPage: tableRows.currentPage, rowsPerPage: tableRows.rowsPerPage })
                    toast.success(t("common.actionSuccessfully"), { containerId: "all_toast" })
                }
            })
            .catch(err => {
                setLoadingFromCis(false)
            })
    }



    const headerButtonsLeft = (
        <div className="d-flex align-items-center gap-2">
            <CisMessage requestBody={{
                object: "GetCompanyInfoRequestLogV",
                params: {
                    type: "TCR"
                },
                company: company.id
            }} />
            {isSysAdmin && editTcrInCisActions}
        </div>
    )

    const headerButtonsRight = (
        <div className="d-flex align-items-center gap-2">
            <div className='prime-table-toolbar__add-btn' onClick={() => { if (!loadingFromCis) getTcrsFromCis() }} style={loadingFromCis ? {opacity: 0.6, pointerEvents: 'none'} : {}}>
                {loadingFromCis ? <Loader size={"xs"} /> : "Get TCR from CIS"}
            </div>
            {(isSysAdmin || user?.role?.id == 3) && <div className="prime-table-toolbar__add-btn" onClick={() => setTcrDialog({ visible: true, tcr: null })}>
                {t('company.registerTCR')}
            </div>}
        </div>
    )

    const headerIcons = (
        <ExportCsvPrime
            selectedColumns={selectedColumns}
            iconOnly
            tooltip="Export CSV"
            data={tcrForCsv}
            columns={tcrColumns}
            onClick={() => getTCR({ updatedFilters: filters, exportCsv: true })}
            excludedColumns={["actions"]}
        />
    )


    return (
        <div>
            {

                <Dialog
                    header={tcrDialog?.tcr ? t("selfServices.editTcr") : t('company.registerTCR')}
                    visible={tcrDialog?.visible}
                    onHide={() => setTcrDialog({ visible: false, tcr: null })}
                    style={{ width: "30vw" }}
                    breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                >
                    {tcrDialog?.visible && <RegisterEditTcr tcr={tcrDialog?.tcr} company={company} setCompany={setCompany} onTcrChanged={() => {
                        getTCR({ updatedFilters: filters, currentPage: tableRows.currentPage, rowsPerPage: tableRows.rowsPerPage });
                        setTcrDialog({ visible: false, tcr: null })
                        if (company.id == selectedCompany) getCompany()
                    }} />}

                </Dialog>
            }


            <div className='prime-header-sticky'>
                {!tcrData ? <Loader /> :
                    <PrimeTable
                        reorderableColumns={true}
                        value={tcrData ?? allTcrs}
                        filters={[filters, setFilters]}
                        defaultFilters={defaultFilters}
                        columns={tcrColumns}
                        responsiveLayout="scroll"
                        paginator={true}
                        columnResizeMode="expand"
                        scrollable={true}
                        scrollHeight="580px"
                        showFilters={true}
                        showSelectColumns={true}
                        gridKey="tcrColumns2"
                        selectedColumns={[selectedColumns, setSelectedColumns]}
                        filterDisplay={"row"}
                        clearFilters={true}
                        rowReorder={false}
                        headerButtonsRight={[1, 2, 3].includes(user?.role?.id) && headerButtonsRight}
                        headerButtonsLeft={[1, 2, 3].includes(user?.role?.id) && headerButtonsLeft}
                        headerIcons={headerIcons}
                        tableRows={[tableRows, setTableRows]}
                        onRemoteDataChange={(remoteData) => {
                            const updatedFilters = remoteData.filters ?? filters;
                            const updatedTableData = remoteData.tableRows ?? tableRows;
                            let { currentPage, rowsPerPage, sortCriteria } = updatedTableData;
                            sortCriteria = sortCriteria ? [sortCriteria] : null;
                            getTCR({ updatedFilters, rowsPerPage, currentPage, sortCriteria });
                        }}
                        rowExpansionTemplate={rowExpansionTemplate}
                        expandedRows={expandedRows}
                        onRowExpand={onRowExpand}
                        onRowCollapse={onRowCollapse}
                    >
                        {isSysAdmin && selectedRowsColumn}
                     { isSysAdmin &&  <Column
                            expander={() => true}
                            style={{ width: "0.5em" }}
                            header=""
                            field="expansion"
                            frozen={true}
                        />}
                    </PrimeTable>
                }
            </div>
        </div>
        

    )
}

export default Tcrs
